import React from 'react';
import { Box, Icon, Typography } from '@drone-js/core';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { BenefitItem } from 'gql/autogen/BenefitItem';
import { BenefitName } from 'gql/autogen/BenefitName';
import { benefitNameCms } from 'component/page/detail/PackageOptions/CollapsedOffer/OfferCardDetail/InclusionListCms';
import AgodaMarkdown from 'component/common/AgodaMarkdown/AgodaMarkdown';
import { TextType } from '@drone-js/theme';

const InclusionItemContent: React.FC<{
    cms: CmsValue;
    description: string;
    isInclusion: boolean;
    contentLocale: string;
    textColor: TextType;
    markdownFormat?: {};
    isOnOfferCard?: boolean;
}> = (props) => {
    return (
        <Box my="8" display="flex" flexDirection="row" data-testid="inclusion-item">
            {props.isInclusion ? (
                <Icon id="fill.symbol.check" size={props.isOnOfferCard ? '14' : '16'} aria-label={props.cms[175931]} color={props.textColor} />
            ) : (
                <Icon id="fill.symbol.close" size={props.isOnOfferCard ? '14' : '16'} aria-label={props.cms[174790]} color={props.textColor} />
            )}
            <Typography
                mx="12"
                variant={props.isOnOfferCard ? 'caption-default' : 'body-s'}
                lang={props.contentLocale}
                textColor={props.textColor}
                lineClamp={props.isOnOfferCard ? 1 : undefined}
            >
                <AgodaMarkdown input={props.description} overrides={props.markdownFormat} />
            </Typography>
        </Box>
    );
};
InclusionItemContent.displayName = 'InclusionItemContent';

export const InclusionItem: React.FC<{
    benefit: BenefitItem;
    cms: CmsValue;
    isInclusion: boolean;
    contentLocale: string;
    textColor: TextType;
    markdownFormat?: {};
    isOnOfferCard?: boolean;
}> = ({ benefit, cms, isInclusion, contentLocale, textColor, markdownFormat, isOnOfferCard }) => {
    if (!benefit || !benefit.name) {
        return null;
    }
    const description = benefit.description || [];
    const descriptionText = benefit.name === BenefitName.OTHER && description.length > 0 ? description[0].trim() : cms[benefitNameCms[benefit.name]];

    return (
        <InclusionItemContent
            description={descriptionText}
            isInclusion={isInclusion}
            cms={cms}
            contentLocale={contentLocale}
            textColor={textColor}
            markdownFormat={markdownFormat}
            isOnOfferCard={isOnOfferCard}
        />
    );
};
InclusionItem.displayName = 'InclusionItemList';
